import { tokens } from "../../theme";
import * as React from "react";

import { Box, IconButton, useTheme, InputBase } from "@mui/material";
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import GreetingHeader from "../../components/GreetingHeader";
import SectionHeader from "../../components/SectionHeader";
import Grid from "@mui/material/Unstable_Grid2"; // Grid version 2
import SearchIcon from "@mui/icons-material/Search";
import ToolbarFilterButton from "../../components/ToolbarFilterButton";
import DatePickerDropdownButton from "../../components/DatePickerDropdownButton";

import ConnectionStatus from "../../utils/ConnectionStatus";
import { SnackbarProvider, useSnackbar } from "notistack";
import UseOnlineStatus from "../../utils/UseOnlineStatus";
import {
  getFromLocalStorage,
  } from "../../utils/localStorageUtils";
import CustomProgressDialog from "../../components/CustomProgressDialog";
import ShowErrorAlertDialog from "../../components/ErrorAlertDialog";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAtom } from "jotai";
import {
  globalSearchText,
  isAuthPageAtom,
  showErrorAlertDialog,
} from "../../config/AppConfig";
import {
  ALERT,
  ERROR_WHILE_FETCHING_DATA,
  ERROR_WHILE_FETCHING_PAYOUT_DETAILS,
  NO_INTERNET_CONNECTION_FOUND,
  YOU_ARE_OFFLINE,
  YOU_ARE_ONLINE,
  LOADING_ACTIVITY_DETAILS,
  SOME_ERROR_OCCURRED
} from "../../constants/Strings";
import { initializeEncryption } from "../../services/AesGcmEncryption";
import DebugLog from "../../utils/DebugLog";
import {
  LOGIN_ID,
  MESSAGE_KEY,
  SESSION_ID,
  USER_NAME,
} from "../../constants/LocalStorageKeyValuePairString";
import {
  generateRandomId,
  generateRequestId,
} from "../../utils/RequestIdGenerator";
import { ApiErrorCode, ApiType } from "../../services/ApiTags";
import {
  getAllPayoutList,
  getPayoutActivityDetails
} from "../../services/ApiService";

import * as CONSTANT from "../../constants/Constant";
import SimpleTable from "../../components/SimpleTable";
import UserActivityInfo from "../../components/UserActivity";

const Payouts = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isNetworkConnectionAvailable = UseOnlineStatus();

  const navigate = useNavigate();
  const [, setAuthStatus] = useAtom(isAuthPageAtom);
  const [getDialogStatus, setErrorDialog] = useAtom(showErrorAlertDialog);
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [isPayoutSummaryLoading, setPayoutSummaryLoading] = useState(false);
  const [title, setTitle] = useState(ALERT);
  const [content, setContent] = useState("");
  const [, setError] = useState("");
  const [getProgressbarText, setProgressbarText] = useState("");

  const [payoutSummary, setPayoutSummary] = useState([]);
  const [payoutActivityDetails, setpayoutActivityDetails] = useState([]);

  const [gridHeight, setGridHeight] = useState(108); // Default height
  const [totalNoOfRows, setTotalNoOfRows] = useState(7); // Default height
  const [apiCallStatus, setApiCallStatus] = useState(true);

  
  const [searchQuery, setSearchQuery] = useAtom(globalSearchText);

  // search bar & filter
  const [searchQueryPlaceholder, setSearchQueryPlaceholder] = useState("Search Name");
  const [searchDealerQuery, setDealerSearchQuery] = useState("");
  const [filter, setFilter] = useState("");
  const [filterCriteria, setFilterCriteria] = useState([{ "keyValue":"","displayName": "", "paramName": "" }]);
  const [filterDisplayOptions, setFilterDisplayOptions] = useState([]);
  const [defaultFilter, setDefaultFilter] = useState("Name");
  const [isDateFilterSelected, setIsDateFilterSelected] = useState(false);
  const [showSearchBarDropdown, setShowSearchBarDropdown] = useState(false);
  const [searchBarDropdownValues, setSearchBarDropdownValues] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const payoutStatusArray = [
    "Pending Review",
    "Pending Approval",
    "Completed",
    "Hold",
    "Cancel",
    "Release Approval",
    "Reject"
  ];
  const commissionTypeArray = [
    "Incentives",
    "Device Reimbursement Broadband",
    "Device Reimbursement Bundle"
  ];

  // pagination for Payout
  const [payoutPageSize, setPayoutPageSize] = useState(15);
  const [payoutCurrentPage, setPayoutCurrentPage] = useState(0);
  const [payoutTotalNoOfPages, setPayoutTotalNoOfPages] = useState(0);

  // Activity Details 
  const [selectedDateRange, setSelectedDateRange] = useState(CONSTANT.ACTIVITY_PERIODS.THREE_MONTHS); 

  // pagination for Activity
  const [activityPageSize, setActivityPageSize] = useState(15);
  const [activityCurrentPage, setActivityCurrentPage] = useState(0);
  const [activityTotalNoOfPages, setActivityTotalNoOfPages] = useState(0);

  const handleDateRangeChange = (selectedDateRange) => {
    setSelectedDateRange(selectedDateRange);
    getActivityDetails(activityCurrentPage, selectedDateRange);
  };

  const handleActivityPageChange = (newPage) => {
    setActivityCurrentPage(newPage);
    getActivityDetails(newPage, selectedDateRange);
  }

  const handlePayoutsPageChange = (newPage) => {
    setPayoutCurrentPage(newPage);
    getPayoutSummaryData(newPage, payoutPageSize, filter, searchDealerQuery);
  }

  // increase - decrease list layout height on available list itmes count
  function getDataGridHeight() {
    // Calculate the total height required for the grid
    const headerHeight = 70; // Height of header row
    const rowHeight = 70; // Height of each data row
    const rowCount = totalNoOfRows; // Total number of data rows
    const totalHeight = headerHeight + rowCount * rowHeight;

    // Set the grid height
    setGridHeight(totalHeight);
  }

  // const startDownload = () => {
  //   showErrorAlert("", "COMING SOON!");
  // };

  useEffect(() => {
   // getPayoutSummaryData(payoutCurrentPage, payoutPageSize, filter, searchDealerQuery);
    getActivityDetails(activityCurrentPage, selectedDateRange);

    setupFilters()
  }, []);

  useEffect(() => {
    getDataGridHeight();

    // get Payout details
    //getPayoutDetail();

    showNoInternetSnackBar();

    navigate(blockNavigation);
  }, [isNetworkConnectionAvailable, enqueueSnackbar, navigate, totalNoOfRows]);

  // const handleRowClick = (params) => {
  //   const pageNumber = 0;
  //   const pageSize = 10;
  //   const payoutRowSelected = {
  //     payoutCycle: params.row.payoutCycle,
  //     cutOffDate: params.row.cutOffDate,
  //     payoutStatus: params.row.payoutStatus,
  //     payoutDate: params.row.payOutDate,
  //     pageNumber: pageNumber,
  //     pageSize: pageSize,
  //   };

  //   DebugLog("payoutRowSelected  " + JSON.stringify(payoutRowSelected));
  //   saveToLocalStorageJsonObject(NAV_PAYOUT_DETAIL_DATA, payoutRowSelected);
  //   navigate(CONSTANT.PAYOUT_ARCHIVE_ROUTE);
  // };

  function blockNavigation(location, action) {
    // Block navigation if action is "pop", which indicates back/forward button press
    if (action === "pop") {
      // Optionally, you can show a message to the user before blocking navigation
      alert("Back button is disabled.");
      return false;
    }
    return true; // Allow navigation for other actions like "push" or "replace"
  }

  /***** API Call *****/
  async function getPayoutSummaryData(pageNumber, pageSize, selectedFilter, searchQuery) {
    try {
      if (isNetworkConnectionAvailable) {
        // setProgressbarText(FETCHING_PAYOUT_SUMMARY_PLEASE_WAIT);
        // setLoading(true); // Hide the progress dialog
        setPayoutSummaryLoading(true);

        const payoutSummaryContentData = createRequestObject(pageNumber, pageSize, selectedFilter, searchQuery);

        initializeEncryption(
          payoutSummaryContentData,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.GET_ALL_PAYOUT_LIST
        ).then((encryptedContentData) => {
          const payoutSummaryRequestData = {
            requestId: generateRequestId(),
            loginId: getFromLocalStorage(LOGIN_ID),
            sessionId: getFromLocalStorage(SESSION_ID),
            contentData: encryptedContentData,
          };

          getAllPayoutList(payoutSummaryRequestData)
            .then((response) => {
              setTotalNoOfRows(response.data.result.content.length);

              const rowsWithIds = response.data.result.content.map((row) => ({
                ...row,
                id: generateRandomId(),
              }));
              setPayoutSummary(rowsWithIds);
              setPayoutTotalNoOfPages(response.data.result.totalPages);
              setPayoutSummaryLoading(false);
            })
            .catch((error) => {
              setPayoutSummaryLoading(false);
              handleError(error);
            });
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_WHILE_FETCHING_PAYOUT_DETAILS + JSON.stringify(message)
      );
    }
  }

  function getActivityDetails(pageNo, passedDateRange) {
    try {
      if (isNetworkConnectionAvailable) {
        DebugLog("getActivityDetails CALLED");
        setProgressbarText(LOADING_ACTIVITY_DETAILS);
         setLoading(true);

        const toDate = new Date();
        let fromDate = new Date();

        let numberOfMonth = 3;

        switch(passedDateRange) {
          case CONSTANT.ACTIVITY_PERIODS.THREE_MONTHS:
            numberOfMonth = 3;
            fromDate.setMonth(toDate.getMonth() - 3);
            break;
          case CONSTANT.ACTIVITY_PERIODS.SIX_MONTHS:
            numberOfMonth = 6;
            fromDate.setMonth(toDate.getMonth() - 6);
            break;
          case CONSTANT.ACTIVITY_PERIODS.ONE_YEAR:
            numberOfMonth = 12;
            fromDate.setFullYear(toDate.getFullYear() - 1);
            break;
          default:
            numberOfMonth = 3;
            fromDate.setMonth(toDate.getMonth() - 3); // default to 3 months if no valid option is selected
        }

        const requestObject = {
          pageNumber: pageNo,
          pageSize: activityPageSize,
          // fromDate: fromDate.toISOString(),
          // toDate: toDate.toISOString(),
          noOfMonth: numberOfMonth,
        };

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.GET_PAYOUT_ACTIVITY_DETAILS
        ).then((encryptedContentData) => {
          const requestData = {
            requestId: generateRequestId(),
            loginId: getFromLocalStorage(LOGIN_ID),
            sessionId: getFromLocalStorage(SESSION_ID),
            loginUserName: getFromLocalStorage(USER_NAME),
            contentData: encryptedContentData,
          };

          getPayoutActivityDetails(requestData)
            .then((response) => {
              DebugLog("getActivityDetails RESPONSE RECEIVED");
              const contentData =
                response.data.result.content.map((row) => ({
                  ...row,
                  id: generateRandomId(),
                }));
                setpayoutActivityDetails(contentData);
              setActivityTotalNoOfPages(response.data.result.totalPages);
              setLoading(false);
            })
            .catch((error) => {
              handleError(error);
            });
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      handleError(error);
    }
  }

  /********** SEARCH & FILTER methods *************/
  function setupFilters() {
    const filterOptions = [
      { "keyValue":"Commission Type", "displayName": "Name", "paramName": "commissionType" },
      { "keyValue":"Payout Status", "displayName": "Status", "paramName": "payoutStatus" },
      { "keyValue":"Cutoff Date", "displayName": "Cutoff", "paramName": "cutoffDate" },
      { "keyValue":"Payout Date", "displayName": "Payout By", "paramName": "payoutDate" },
      { "keyValue":"Commission Type Dropdown", "displayName": "Commission Type", "paramName": "commissionType" },
    ];

    setFilterCriteria(filterOptions);
    setFilterDisplayOptions(filterOptions.map((item) => item.displayName));
    setDefaultFilter(filterOptions[0].displayName);
    setFilter(filterOptions[0]);
  }

  // create useEffect to clear search query when a new filter is selected
  useEffect(() => {
    const placeholder = "Search " + filter.displayName;
    setSearchQueryPlaceholder(placeholder);
    setDealerSearchQuery("");
    onSearchButtonClicked("");
  }, [filter]);

  const handleFilterChange = (filter) => {
    // find the right filterCriteria based on the selected filter
    const selectedFilter = filterCriteria.find((item) => item.displayName === filter);
    setFilter(selectedFilter);

    // check if the selected filter is "Date" and update state accordingly
    if (selectedFilter.paramName === "cutoffDate" || selectedFilter.paramName === "payoutDate") {
      setIsDateFilterSelected(true);
    } else {
      setIsDateFilterSelected(false); 
    }

    // Check if the selected filter is "payoutStatus" and update state accordingly
    if (selectedFilter.keyValue === "Payout Status") {
      setSearchBarDropdownValues(payoutStatusArray);
      setShowSearchBarDropdown(true);
    } else if (selectedFilter.keyValue === "Commission Type Dropdown"){
      setSearchBarDropdownValues(commissionTypeArray);
      setShowSearchBarDropdown(true);
    }else {
      setShowSearchBarDropdown(false); // Hide the dropdown if another filter is selected
    }
  };

  const handleSearchBarDropdownSelect = (selectedValue) => {
    // const selectedTierFilter = event.target.value;
    const selectedTierFilter = selectedValue;
    setDealerSearchQuery(selectedTierFilter);

    // when handling search, set pagination page to 0
    setPayoutCurrentPage(0);
    getPayoutSummaryData(0, payoutPageSize, filter, selectedTierFilter);

    handleCloseSearchBarDropdown();
  };

  const handleOpenSearchBarDropdown = (event) => {
    if (showSearchBarDropdown) {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleCloseSearchBarDropdown = () => {
    setAnchorEl(null);
  };

  function onSearchButtonClicked( instantSearchQuery ) {
    // when handling search, set pagination page to 0
    setPayoutCurrentPage(0);
    if (instantSearchQuery != null && instantSearchQuery != undefined) {
      getPayoutSummaryData(0, payoutPageSize, filter, instantSearchQuery);
    } else {
      getPayoutSummaryData(0, payoutPageSize, filter, searchDealerQuery);
    }
    // setPaginationModel({ pageSize: pageSize, page: 0 });
    // getCashOutLimitDetailsData( 0, paginationModel.pageSize, filter, searchDealerQuery);
  }

  // Create Request Object for searchAllAccountEarmarkDetails API
  function createRequestObject(pageNumber, pageSize, selectedFilter, filterValue) {
    // Initialize all fields to null
    let requestObject = {
      // commissionType: null,
      // payoutStatus: null,
      // payoutDate: null,
      // cutoffDate: null,
      pageNumber: pageNumber,
      pageSize: pageSize,

      sortOrder: null,
      sortProperty: null,
    };
  
    // Set the appropriate field based on filterCriteria
    if (selectedFilter != null && selectedFilter != undefined && selectedFilter != "" && selectedFilter.paramName != "") {
      if (filterValue != null && filterValue != undefined && filterValue != "") {
        requestObject[selectedFilter.paramName] = filterValue;
      }
    }

    return requestObject;
  }

  /******* END of SEARCH & FILTER methods */

  // handle error code reusable block
  function handleError(error) {
    setLoading(false);

    if (error.message === NO_INTERNET_CONNECTION_FOUND) {
      // Handle no internet connection error
      showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      return;
    } 

    const errorCode = error.data?.errorCode;
    var errorMessage =
        error.data != null
            ? error.data.displayErrorMessage
            : SOME_ERROR_OCCURRED;
    if (error.data?.displayErrorMessage) {
      errorMessage = error.data.displayErrorMessage;
    }

    const errorActions = {
      [ApiErrorCode.SESSION_EXPIRED]: () => navigate(CONSTANT.LOGIN),
      [ApiErrorCode.SESSION_ID_NOT_FOUND]: () => navigate("/"),
      [ApiErrorCode.UNABLE_TO_PROCESS_ERROR]: () => navigate(CONSTANT.FINANCE_DASHBOARD),
      default: () => showErrorAlert(
        error.message,
        ERROR_WHILE_FETCHING_DATA + JSON.stringify(errorMessage)
      ),
    };
  
    (errorActions[errorCode] || errorActions.default)();
  }

  function showErrorAlert(title, content) {
    try {
      DebugLog("error.data=====" + content);
      setError();
      setLoading(false);

      setTitle(title);
      setContent(content);
      setErrorDialog(true);
    } catch (error) {
      DebugLog(error);
    }
  }

  const showNoInternetSnackBar = () => {
    if (isNetworkConnectionAvailable) {
      enqueueSnackbar(YOU_ARE_ONLINE);
    } else {
      enqueueSnackbar(YOU_ARE_OFFLINE, {
        autoHideDuration: 3000,
        variant: "error",
      });
    }
  };

  const handlePayoutsRowClicked = ((
    pPayoutCycleName, 
    pBatchNo, 
    pVersionNo, 
    pCommissionType,
    pShowApproval,
    pShowCancel,
    pShowHold,
    pShowRelease,
    pShowRequestApproval,
    pShowRequestRelease,
  ) => {
    DebugLog("handlePayoutsRowClicked executed")
    navigate(
      CONSTANT.PAYOUT_ARCHIVE_ROUTE, 
      { state: { 
          batchNo: pBatchNo, 
          version: pVersionNo,
          payoutCycleName: pPayoutCycleName, 
          commissionType: pCommissionType,

          showApproval: pShowApproval,
          showCancel: pShowCancel,
          showHold: pShowHold,
          showRelease: pShowRelease,
          showRequestApproval: pShowRequestApproval,
          showRequestRelease: pShowRequestRelease,
          
          flowFrom: CONSTANT.PAYOUT_ROUTE,
       } }
    );
  });

  return (
    /* Main Container */
    <Box>
      <SnackbarProvider maxSnack={3}>
        <ConnectionStatus />
        <ShowErrorAlertDialog
          status={getDialogStatus}
          title={title}
          content={content}
        />
        {isNetworkConnectionAvailable ? (
          <CustomProgressDialog open={loading} text={getProgressbarText} />
        ) : (
          showNoInternetSnackBar()
        )}

        <Grid
          container
          component="main"
          direction={"column"}
          sx={{
            // height: "100vh",
            m: "0 2.5%" /* Approx 30px */,
            borderRadius: "18px",
          }}
        >
          {/* Greetings Header */}
          <Grid container>
            <Grid item>
              <GreetingHeader name={"Payouts"}></GreetingHeader>
            </Grid>

            <Box position="absolute" right={30} top={75}>
              <Grid
                  container
                  direction={'row'}
                  alignItems={'top'}
              >
                {/* Conditional Rendering - either show date picker or search bar */}
                { isDateFilterSelected ? (
                  <Box
                    backgroundColor={colors.grey[900]}
                    borderRadius="20px"
                    ml={5}
                    mr={2}
                  >
                    <DatePickerDropdownButton
                      onDateSelect={(selectedDate) => {
                        setDealerSearchQuery(selectedDate);
                        onSearchButtonClicked(selectedDate);
                      }}
                    />
                  </Box>
                ) : (
                  // Search bar
                  <Box
                      backgroundColor={colors.grey[900]}
                      borderRadius="20px"
                      ml={5}
                      mr={2}
                  >
                    <InputBase
                        sx={{ ml: 2, flex: 1 }}
                        placeholder={searchQueryPlaceholder}
                        value={searchDealerQuery}
                        onClick={handleOpenSearchBarDropdown}
                        onChange={(e) =>
                            setDealerSearchQuery(e.target.value)
                        }
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            onSearchButtonClicked();
                            e.preventDefault(); // Prevent form submission & page refresh
                          }
                        }}
                    />

                    <Menu
                      id="simple-menu"
                      anchorEl={anchorEl}
                      open={Boolean(anchorEl) && showSearchBarDropdown}
                      onClose={handleCloseSearchBarDropdown}
                      anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                      }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                      }}
                    >
                      {searchBarDropdownValues.map((status) => (
                          <MenuItem 
                            key={status}
                            onClick={() => handleSearchBarDropdownSelect(status)}
                          >
                            {status}
                          </MenuItem>
                        ))}
                    </Menu>

                    <IconButton 
                      type="button" 
                      sx={{ p: 1 }}
                      onClick={() => onSearchButtonClicked()}
                    >
                        <SearchIcon/>
                    </IconButton>
                  </Box>
                )}

                

                <ToolbarFilterButton
                    options={filterDisplayOptions}
                    defaultOption={defaultFilter}
                    onChange={handleFilterChange}
                    name={"FILTERS"}
                />
            </Grid>
          </Box>
          </Grid>
          {/* Greetings Header */}

          {/* Payouts Section */}
          <Grid
            container
            mt={3}
            border={"1px solid" + colors.grey[600]}
            borderRadius={2}
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
          >
            <SectionHeader
              // sectionIcon={"../../assets/common/Payouts.svg"}
              sectionIcon={
                <svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M32.9993 18.6953C32.9993 26.9753 26.2793 33.6953 17.9993 33.6953C9.71927 33.6953 2.99927 26.9753 2.99927 18.6953C2.99927 10.4153 9.71927 3.69531 17.9993 3.69531C26.2793 3.69531 32.9993 10.4153 32.9993 18.6953Z" stroke="black" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M23.5663 23.4659L18.9163 20.6909C18.1063 20.2109 17.4463 19.0559 17.4463 18.1109V11.9609" stroke="black" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
              }
              sectionHeading={"Payouts"}
            ></SectionHeader>

            <SimpleTable
              loading={isPayoutSummaryLoading}
              statusData={"Needs Approval"}
              data={payoutSummary}
              onRowClicked={handlePayoutsRowClicked}
              totalNoOfPages={payoutTotalNoOfPages}
              onPageChange={handlePayoutsPageChange}
            ></SimpleTable>
          </Grid>

          {/* Validations Section */}
          {/* <Grid
            container
            mt={3}
            border={"1px solid" + colors.grey[600]}
            borderRadius={2}
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            pb={2}
          >
            

            {payoutSummary.length > 0 ? (
              <Box
                borderRadius={3}
                flex={1}
                m="0px 0 0 0"
                pb={0}
                height={gridHeight}
                sx={{
                  "& .MuiDataGrid-root": {
                    border: "none",
                  },
                  "& .MuiDataGrid-cell": {
                    borderBottom: "none",
                  },
                  "& .name-column--cell": {
                    color: colors.redAccent[200],
                    fontWeight: "bold",
                    fontSize: 13,
                  },
                  "& .MuiDataGrid-columnHeaders": {
                    backgroundColor: "rgba(255,255,255,0.6)",
                    borderBottom: "none",
                    fontWeight: "bold",
                    fontSize: "13px",
                    color: `${colors.grey[300]} !important`,
                  },
                  "& .MuiDataGrid-virtualScroller": {
                    background: "rgba(255,255,255,1)",
                  },
                  "& .MuiDataGrid-footerContainer": {
                    borderTop: "none",
                    backgroundColor: "rgba(255,255,255,0.6)",
                  },
                  "& .MuiCheckbox-root": {
                    //color: `${colors.white[200]} !important`,
                  },
                  "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                    color: `${colors.grey[300]} !important`,
                   // backgroundColor: "rgba(255,255,255,0.6)",
                   // opacity:.5
                 },
                }}
              >
                <DataGrid
                  rows={filteredRows.slice(
                    currentPage * pageSize,
                    (currentPage + 1) * pageSize
                  )}
                  columns={payoutSummaryColumnHeader}
                  components={{ Toolbar: GridToolbar }}
                  pageSize={pageSize}
                  //rowsPerPageOptions={[5, 10, 20]}
                  rowCount={filteredRows.length}
                  pagination
                  onPageChange={handlePageChange}
                  useResizeContainer
                  onRowClick={handleRowClick}
                />
              </Box>
            ) : (
              NoDataFound()
            )}

          </Grid> */}
          {/* Validations Section */}

          {/* {payoutSummary.length > 0 ? (
            <Box>
              <Typography>
                <span>Jump to page: </span>
                <select value={currentPage + 1} onChange={handlePageJump}>
                  {[...Array(totalNoOfRows)].map((_, index) => (
                    <option key={index} value={index + 1}>
                      {index + 1}
                    </option>
                  ))}
                </select>
              </Typography>
            </Box>
          ) : (
            ""
          )} */}



        {/* activity list */}
        <Grid container>
            
            <UserActivityInfo  
              type={"Payouts"} 
              data={payoutActivityDetails}
              ondateRangeChange={handleDateRangeChange}
              totalNoOfPages={activityTotalNoOfPages}
              onPageChange={handleActivityPageChange}
              />
            {/* activity list */}
        </Grid>

        </Grid>
      </SnackbarProvider>
    </Box>
    /* Main Container */
  );
};

export default Payouts;
